import { NavigationGuard } from 'vue-router';
import { routes } from '@/router';
import { HOME } from '@/routerNames';

const RedirectMiddleware: NavigationGuard = (to, from, next) => {
  const routeNames = routes.map((r) => r.name);
  if (!routeNames.includes(to.name as string)) {
    return next({ name: HOME });
  }
  next();
};

export default RedirectMiddleware;
